export const PRODUCE_TYPE_PICTURE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.heic', '.gif', '.svg', '.bmp', '.webp', '.tif', '.tiff'];
export const REPORT_PICTURE_EXTENSIONS = ['.jpg', '.png', '.jpeg', '.heic'];

class PictureProcessingService {
  isPictureFileName(fileName, validExtensions = PRODUCE_TYPE_PICTURE_EXTENSIONS) {
    return validExtensions.some(extension => fileName?.toLowerCase().endsWith(extension));
  };

  async readPictureFile(file, validExtensions = PRODUCE_TYPE_PICTURE_EXTENSIONS) {
    if (!file) {
      return {
        fileSelected: false,
        isValid: true,
        photoData: null,
      };
    }

    if (!this.isPictureFileName(file.name, validExtensions)) {
      return {
        fileSelected: true,
        isValid: false,
        photoData: null,
      };
    }

    return {
      fileSelected: true,
      isValid: true,
      photoData: await this.readFileAsDataUrl(file),
    };
  };

  readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
};

export default new PictureProcessingService();
